import appGlobalScript from '/home/mirna.mendonca@sydle.net/Documentos/sydle-ui-blog/blog/packages/sydle-ui-blog/src/global/app.ts';
export const globalScripts = appGlobalScript;
